import useFetchApi from '@helpers/useFetchApi';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

interface CreateSubscriptionResponse {
  cardBrand: string | null;
  cardLastFour: string | null;
  gracePeriod: string | null;
  hasCanceled: boolean;
  plan: string;
}

interface Subscription {
  paymentMethodId: string;
  plan: string;
}

export default function useCreateSubscription(): UseMutationResult<
  CreateSubscriptionResponse,
  unknown,
  Subscription
> {
  const fetchApi = useFetchApi();

  const queryClient = useQueryClient();

  return useMutation<CreateSubscriptionResponse, unknown, Subscription>(
    subscription => fetchApi.post('/api/subscription/', subscription),
    {
      onSuccess: newSubscription => {
        queryClient.setQueryData('subscription', newSubscription);
      },
    }
  );
}
